// extracted by mini-css-extract-plugin
module.exports = {"root":"mdx_root__37Glm"};